import { render, staticRenderFns } from "./CardTarjaTropaGE.vue?vue&type=template&id=7c558326&scoped=true"
import script from "./CardTarjaTropaGE.vue?vue&type=script&lang=js"
export * from "./CardTarjaTropaGE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTropaGE.vue?vue&type=style&index=0&id=7c558326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c558326",
  null
  
)

export default component.exports